import axios from 'axios'
import helper from "./helper";

let API = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/api",
    timeout: 60000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem(helper.ADMIN_TOKEN)
    }
});

export default API
